<template>
  <div class="system_serve_list">
    <el-form v-model="queryData">
      <el-row>
        <el-button
          class="search"
          type="primary"
          @click="addchandise"
        >添加</el-button>
      </el-row>
    </el-form>
    <el-table
      class="table"
      :data="tableData"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}"
      style="width: 98.5%; margin-top: 30px; margin-left: 10px"
      highlight-current-row
    >
      <el-table-column prop="id" label="id" />
      <el-table-column prop="userName" label="客服名称" />
      <el-table-column prop="serviceLogo" label="客服图标">
        <template slot-scope="scope">
          <el-popover placement="top-start" title="" trigger="hover">
            <img
              :src="scope.row.serviceLogo"
              alt=""
              style="width: 240px; height: 150px"
            >
            <img
              slot="reference"
              :src="scope.row.serviceLogo"
              style="width: 50px; height: 30px"
            >
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="serviceUrl" label="地址" />
      <el-table-column prop="phone" label="账号" />
      <el-table-column prop="businessCode" label="业务员码" />
      <el-table-column prop="serviceBusinessType" label="服务类型" />
      <el-table-column label="操作" width="235">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            class="edeit"
            @click="handleEdit(scope.row)"
          >修改</el-button>
          <el-button
            type="text"
            size="small"
            class="edeit"
            @click="handleDel(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      background
      :current-page="queryData.pageNo"
      :page-sizes="[15, 30, 50, 100, 200]"
      :page-size="queryData.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    <!-- 添加弹框 -->
    <el-dialog
      :title="title"
      :visible.sync="adddialogFormVisible"
      style="margin: 100px 0 0 0"
    >
      <el-form ref="form" :model="form" label-width="110px" class="proeditform">
        <el-form-item label="图标:" class="picture">
          <el-upload
            class="upload-demo"
            drag
            action="#"
            accept=".jpeg, .png, .jpg"
            :before-upload="beforeFile"
            :limit="1"
          >
            <img v-if="url" :src="url" alt="" class="pica">
            <div v-else>
              <i class="el-icon-upload" />
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
            </div>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="客服名称:" prop="phone">
          <el-input
            v-model="form.userName"
            placeholder="请输入客服名称"
          />
        </el-form-item>
        <el-form-item label="地址:" prop="phone">
          <el-input
            v-model="form.serviceUrl"
            placeholder="请输入地址"
          />
        </el-form-item>
        <el-form-item label="账号:" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入账号" />
        </el-form-item>

        <el-form-item label="业务员码:" prop="phone">
          <el-input
            v-model="form.businessCode"
            placeholder="请输入业务员码"
          />
        </el-form-item>
        <el-form-item label="服务类型:" prop="phone">
          <el-input
            v-model="form.serviceBusinessType"
            placeholder="请输入服务类型"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          class="cancel"
          @click="adddialogFormVisible = false"
        >取 消</el-button>
        <el-button
          type="primary"
          @click="adddialogFormVisibleClk"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { get, post } from '@/utils/request'
import { getToken } from '@/utils/auth'
import axios from 'axios'
import sha256 from 'crypto-js/sha256'

export default {
  name: 'SystemRoles',
  components: {},
  data() {
    return {
      title: '',
      url: '',
      adddialogFormVisible: false,
      tableData: [],
      queryData: {
        pageNo: 1,
        pageSize: 15
      },
      form: {
        id: '',
        userName: '',
        serviceLogo: '',
        serviceUrl: '',
        phone: '',
        businessCode: '',
        serviceBusinessType: '1'
      },
      total: 0
    }
  },
  created() {
    this.getList()
  },
  methods: {
    handleDel(row) {
      this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const id = row.id
          post('/admin/baseService/v1/delete', { id }).then((res) => {
            if (res.status != 200) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.getList()
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    adddialogFormVisibleClk() {
      this.form.serviceLogo = this.url
      post('/admin/baseService/v1/save', this.form).then((res) => {
        if (res.status != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.$message({
            type: 'success',
            message: '请求成功!'
          })
          this.getList()
          this.adddialogFormVisible = false
        }
      })
    },
    handleEdit(row) {
      this.title = '编辑'
      this.adddialogFormVisible = true
      this.form.id = row.id
      this.form.userName = row.userName
      this.url = row.serviceLogo
      this.form.serviceUrl = row.serviceUrl
      this.form.phone = row.phone
      this.form.businessCode = row.businessCode
    },
    addchandise() {
      this.form = {}
      this.form.serviceBusinessType = '1'
      this.title = '添加'
      this.adddialogFormVisible = true
    },
    // 上传图片
    beforeFile(file) {
      const formData = new FormData()
      formData.append('multipartFile', file)
      const token = getToken()
      const _this = this
      const timestamp = Date.now()
      const sign = '213z@W!X#$%&'
      axios
        .post('https://api.maerskwork.com/hub/file/upload', formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            'X-timestamp': timestamp,
            'X-sign': sha256(sign + JSON.stringify(formData || {}) + timestamp)
          }
        })
        .then(function(res) {
          _this.url = res.data.data
          _this.fileList.push({ url })
        })
        .catch(function(error) {})
    },
    clear() {
      this.getList()
    },
    handleSizeChange(val) {
      this.queryData.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.queryData.pageNo = val
      this.getList()
    },
    getList() {
      get('/admin/baseService/v1/list', this.queryData).then((res) => {
        this.tableData = res.data.list
        this.total = res.data.total
      })
    }
  }
}
</script>
